export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  HOME: '/home',
}
